import { Fragment, useCallback } from 'react';

import { rage } from '~/rage';
import { IPlayerVehicleListItem, PlayerVehicleSource } from '~/shared';

import { useLayoutDispatch, useLayoutSelector } from '../../redux/hooks';
import { setSelectedId } from '../../redux/slices/vehicleListSlice';
import { Divider } from '../Divider';
import { VehicleRow } from '../VehicleRow';

interface IVehicleListProps {
	entries: IPlayerVehicleListItem[];
	list: 'work' | 'spawned' | 'nonSpawned';
}

const VehicleList = ({ entries, list }: IVehicleListProps) => {
	const selectedId = useLayoutSelector((state) => state.vehicleList.selectedId);
	const dispatch = useLayoutDispatch();

	const handleClick = (entryId: string, index: number) => {
		dispatch(setSelectedId({ entryId, index, list }));
	};

	const handleDoubleClick = useCallback(
		async (entryId: string, index: number) => {
			dispatch(setSelectedId({ entryId, index, list }));

			try {
				await rage.vehicles.spawnPlayerVehicle(entryId);
			} catch (error) {
				rage.notifications.showException(error);
			}
		},
		[list],
	);

	const handleFavoriteClick = (entry: IPlayerVehicleListItem) => {
		if (entry.source !== PlayerVehicleSource.Owned) return;

		rage.vehicles
			.setVehicleFavorite(entry.id, !entry.isFavorite)
			.catch((err) => rage.notifications.showException(err));
	};

	const handleCrossClick = (entryId: string) => {
		rage.vehicles
			.destroyPlayerVehicle(entryId)
			.catch((err) => rage.notifications.showException(err));
	};

	return (
		<Fragment>
			{entries.map((entry, index) => (
				<Fragment key={entry.id}>
					{index === 0 && <Divider />}
					<VehicleRow
						data={entry}
						selected={selectedId === entry.id}
						id={`vehicle${entry.id}`}
						onRowClick={() => handleClick(entry.id, index)}
						onRowDoubleClick={() => handleDoubleClick(entry.id, index)}
						onFavoriteClick={() => handleFavoriteClick(entry)}
						onCrossClick={() => handleCrossClick(entry.id)}
					/>
					<Divider />
				</Fragment>
			))}
		</Fragment>
	);
};

export { VehicleList };
